import React from 'react';
import Select from 'react-select'
import { components } from "react-select"
import Icon from '@mdi/react'
import { inputStyles } from './Constants'
import styles from './MusicSelector.module.css'
import { mdiChevronDown, mdiClose } from '@mdi/js';
import UploadRecordingModal from './UploadRecordingModal';
import I18N from '../classes/I18N';
import translations from '../lang/components/MusicSelector.lang.json';

const i18n = new I18N(translations);

const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <Icon path={mdiChevronDown} size={1} />
      </components.DropdownIndicator>
    );
};

const options = [
  {file: "music/Alaska Sky - Patrick Patrikios.mp3", label: 'Alaska Sky', duration: 125},
  {file: "music/Another Breath - Futuremono.mp3", label: 'Another Breath', duration: 145},
  {file: "music/Apolllo - Patrick Patrikios.mp3", label: 'Apollo', duration: 133},
  {file: "music/Beth - VYEN.mp3", label: 'Beth', duration: 123},
  {file: "music/Blue Moon - JVNA.mp3", label: 'Blue Moon', duration: 213},
  {file: "music/Checkmate - Nathan Moore.mp3", label: 'Checkmate', duration: 143},
  {file: "music/Dynamite - Patrick Patrikios.mp3", label: 'Dynamite', duration: 139},
  {file: "music/Fender Bender - Bad Snacks.mp3", label: 'Fender Bender', duration: 97},
  {file: "music/Fire Dancer - Reed Mathis.mp3", label: 'Fire Dancer', duration: 155},
  {file: "music/Flickering - VYEN.mp3", label: 'Flickering', duration: 133},
  {file: "music/Frolic - E's Jammy Jams.mp3", label: 'Frolic', duration: 195},
  {file: "music/Glory Be - Patrick Patrikios.mp3", label: 'Glory Be', duration: 153},
  {file: "music/Good Times - Patrick Patrikios.mp3", label: 'Good Times', duration: 120},
  {file: "music/Honey - Bad Snacks.mp3", label: 'Honey', duration: 144},
  {file: "music/Images of Tomorrow - Unicorn Heads.mp3", label: 'Images of Tomorrow', duration: 389},
  {file: "music/Keep It 98 Plus 2 - RAGE.mp3", label: 'Keep It 98 Plus 2', duration: 131},
  {file: "music/Milk - The Mini Vandals.mp3", label: 'Milk', duration: 132},
  {file: "music/Monument - TrackTribe.mp3", label: 'Monument', duration: 252},
  {file: "music/Oceans, Rivers, Canyons - ELPHNT.mp3", label: 'Oceans', duration: 208},
  {file: "music/Orbit - Corbyn Kites.mp3", label: 'Orbit', duration: 104},
  {file: "music/Panda Clan - DJ Williams.mp3", label: 'Panda Clan', duration: 198},
  {file: "music/QuangerineCream - Noir Et Blanc Vie.mp3", label: 'QuangerineCream', duration: 166},
  {file: "music/Recess - TrackTribe.mp3", label: 'Recess', duration: 182},
  {file: "music/Sleepy Hollow - E's Jammy Jams.mp3", label: 'Sleepy Hollow', duration: 166},
  {file: "music/Song of Mirrors - Unicorn Heads.mp3", label: 'Song of Mirrors', duration: 378},
  {file: "music/Sprightly Pursuit - Cooper Cannell.mp3", label: 'Sprightly Pursuit', duration: 106},
  {file: "music/Thinking Of Us - Patrick Patrikios.mp3", label: 'Thinking Of Us', duration: 139},
  {file: "music/TrueArtRealAffectionPart4 - Noir Et Blanc Vie.mp3", label: 'TrueArtRealAffectionPart4', duration: 166},
  {file: "music/Where To - Birocratic.mp3", label: 'Where To', duration: 110},
  {file: "music/Winner Winner Funky Chicken Dinner - The Whole Other.mp3", label: 'Winner Winner Funky Chicken Dinner', duration: 141}
]

class MusicSelector extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        musicActive: this.props.preload ? this.props.preloadEnableMusic : false,
        song: null,
        voiceoverActive: this.props.preload ? this.props.preloadEnableVoiceover : false,
        showUploadRecordingModal: false,
        selectedFile: null
      }
      this.handleClick = this.handleClick.bind(this);
      this.handleMusicChange = this.handleMusicChange.bind(this);
    }

    loadListings = (search) => {
        return fetch(`${process.env.REACT_APP_KVCORE_API_URI}/listings/elastic?search=${search}`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${this.props.jwt}`
            }
        }).then(response => response.json()).then(data => data.data)
    };

    handleChange = (newValue) => {
      if (!newValue) {
        this.setSelectedFile(null);
      }
    }

    handleClick = () => {
      const enabled = !this.state.musicActive
      this.setState({musicActive: enabled})
      this.props.onMusicEnabledChange(enabled)
    }

    handleVoiceoverClick = () => {
      const enabled = !this.state.voiceoverActive;
      if(!enabled) {
        this.setSelectedFile(null);
      }
      this.setState({voiceoverActive: enabled});
      this.props.onVoiceoverEnabledChange(enabled);
    }

    handleClearPreloadedVoiceover = () => {
      this.handleVoiceoverClick();
      this.props.onClearPreloadedVoiceover();
    }

    handleMusicChange = (song) => {
      this.setState({song});
      this.props.onMusicChange(song);
    }

    setShowUploadRecordingModal = (show) => {
      this.setState({showUploadRecordingModal: show});
    }

    setSelectedFile = (file) => {
      this.setState({selectedFile: file})
      this.props.onFileSelected(file);
    }

    render() {
      return (
        <div>
          <div style={{display: "flex", justifyContent: 'space-between', marginBottom: "20px"}}>
            <div style={{display: "flex"}}>
              <div style={{display: "grid", marginRight: "14px"}}>
                  <svg className={"icons-color"} style={{alignSelf: "center"}} width="17" height="20" viewBox="0 0 13 20" stroke="currentColor" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.5 0.5V11.6361C5.86083 11.2772 5.12417 11.0556 4.33333 11.0556C1.93917 11.0556 0 12.945 0 15.2778C0 17.6106 1.93917 19.5 4.33333 19.5C6.7275 19.5 8.66667 17.6106 8.66667 15.2778V4.72222H13V0.5H6.5Z"/>
                  </svg>
              </div>
              <div style={{fontSize: "18px", color: "#444444"}}>
                  {i18n.t(this.props.locale, 'audio')}
              </div>
            </div>
            {this.state.musicActive ?
              (<div style={{textAlign: "right", fontSize: "11px", fontStyle: "italic", fontWeight: "300", color: "#444444"}}>
                  {i18n.t(this.props.locale, 'playToPreview')}
              </div>) : ('')}
          </div>
          <div style={{display: "flex"}}>
            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", minWidth: "124px"}}>
              <span className={styles.baseSwitch}>
                <span className={styles.materialSwitch} onClick={this.handleClick}>
                    <input
                      type="checkbox"
                      onChange={this.handleChange}
                      checked={!!this.state.musicActive || (this.props.preload && this.props.preloadEnableMusic )}
                    />
                    <label className="label-primary">&nbsp;</label>
                  </span>
                  <label className={styles.switchLabel}><slot>{i18n.t(this.props.locale, 'musicToggleLabel')}</slot></label>
              </span>
            </div>
            { this.props.preload && this.props.preloadEnableMusic
              ? (
                  <Select classNamePrefix="react-select"
                    components={{DropdownIndicator}}
                    placeholder={i18n.t(this.props.locale, 'selectMusic')}
                    getOptionLabel={(option) => `${option.label}`}
                    getOptionValue={(option) => option.file}
                    options={options}
                    onChange={this.handleMusicChange}
                    styles={inputStyles}
                    value={this.props.preloadedMusicValue}
                  />
                )
              : (
                  <Select classNamePrefix="react-select"
                    components={{DropdownIndicator}}
                    placeholder={i18n.t(this.props.locale, 'selectMusic')}
                    getOptionLabel={(option) => `${option.label}`}
                    getOptionValue={(option) => option.file}
                    options={options}
                    isDisabled={!this.state.musicActive}
                    onChange={this.handleMusicChange}
                    styles={inputStyles}
                  />
                )
            }
          </div>
          <div style={{display: "flex", marginTop: "30px"}}>
            <div style={{display: "flex", justifyContent: "center", minWidth: "124px"}}>
              <span className={styles.baseSwitch}>
                <span className={styles.materialSwitch} onClick={this.handleVoiceoverClick}>
                    <input
                      type="checkbox"
                      onChange={this.handleChange}
                      checked={!!this.state.voiceoverActive || (this.props.preload && this.props.preloadEnableVoiceover )}
                    />
                    <label className="label-primary">&nbsp;</label>
                  </span>
                  <label className={styles.switchLabel}><slot>{i18n.t(this.props.locale, 'voiceover')}</slot></label>
              </span>
              { this.state.selectedFile || (this.props.preloadEnableVoiceover && this.props.preloadedVoiceoverFile)
                ? (
                    <label className="selectedFile">
                      <span>
                        { (this.props.preloadEnableVoiceover && this.props.preloadedVoiceoverFile)
                          ? this.props.preloadedVoiceoverFile.path
                          : this.state.selectedFile.name
                        }
                      </span>
                      <Icon path={mdiClose} size={1} style={{cursor: 'pointer'}} onClick={(this.props.preloadEnableVoiceover && this.props.preloadedVoiceoverFile) ? this.handleClearPreloadedVoiceover : this.handleVoiceoverClick} />
                    </label>
                )
                : (
                    <button disabled={!this.state.voiceoverActive} className="active" onClick={() => this.setShowUploadRecordingModal(true)}>
                      {i18n.t(this.props.locale, 'uploadRecording')}
                    </button>
                )
              }
            </div>
          </div>
          <p className={styles.disclaimer}>{i18n.t(this.props.locale, 'disclaimer')}</p>
          <UploadRecordingModal
            show={this.state.showUploadRecordingModal}
            onFileSelected={this.setSelectedFile}
            onClose={() => this.setShowUploadRecordingModal(false)}
            locale={this.props.locale}
        />
        </div>
      );
    }
  }

  export default MusicSelector;
